/**
 * Home page “latest release” promo. Update when you ship a new version
 * (keep in sync with the first entry in ReleasesSection and the release file).
 */
export const latestReleaseHome = {
  version: 'v1.10.4',
  /** Same style as the release sidebar: dd/Mmm/yyyy or TBC */
  date: '22nd May 2026',
  title: 'Fresh look, fresh features & now you can select a different blind alert sound!',
  /** One or two sentences for the summary card */
  summary:
    'A big one! Poppy Poker gets a visual overhaul and a stack of quality-of-life improvements.',
  /** Optional short bullets (omit or leave empty [] if you only want the summary) */
  highlights: [
    'Major GUI revamp, admin editing, user preferences, blind level alerts, and more',
  ],
};
